import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "item"]

  add() {
    const itemCount = this.itemTargets.length
    const newItem = document.createElement('div')
    newItem.className = 'flex gap-2'
    newItem.setAttribute('data-learning-outcomes-target', 'item')
    newItem.innerHTML = `
      <input type="text"
             name="course_section[learning_outcomes][]"
             value=""
             class="flex-1 px-4 py-2 rounded-xl border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-gray-900"
             placeholder="Learning outcome ${itemCount + 1}">
      <button type="button"
              data-action="click->learning-outcomes#remove"
              class="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    `
    this.containerTarget.appendChild(newItem)

    const input = newItem.querySelector('input')
    input.focus()
  }

  remove(event) {
    const item = event.target.closest('[data-learning-outcomes-target="item"]')
    if (this.itemTargets.length > 1) {
      item.remove()
    } else {
      item.querySelector('input').value = ''
    }
  }
}
